<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>{{title}}</h3>
            </v-flex>
            <v-flex xs12 sm6>
            </v-flex>

            <v-flex xs12 sm12 md12>
                <v-toolbar flat color="white">
                    <!--<v-toolbar-title>Expandable Table</v-toolbar-title>-->
                    <div>
                        <slot name="select"></slot>
                        <slot name="cancel"></slot>
                    </div>
                    <v-text-field
                            v-model.trim="search"
                            label="Фильтр"
                            v-on:change="initialize(true)"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-icon
                            large
                            class="mr-2 mt-4"
                            @click="initialize()"
                    >
                        mdi-magnify
                    </v-icon>
                </v-toolbar>
                <v-data-table
                        :items="listExportPayment.results"
                        :server-items-length="listExportPayment.last_page"
                        :loading="listLoading.includes('gis_gmpListExportPayment')"
                        hide-default-footer
                        v-model="selected"
                        :headers="headers"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1"
                        item-key="id"
                        :show-select="showSelect"
                        :single-select="true"
                >
                    <template v-slot:item.report="{ item }">
                        <v-btn color="green darken-1"
                               text
                               :to="{name: 'gis_gmp_receipt_export_payment', params: {'id': item.id}}"
                        >
                            Квитанция
                        </v-btn>
                    </template>
                    <template slot="no-data">
                        <v-btn color="primary" @click="initialize">Перегрузить</v-btn>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="listExportPayment.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
<!--            <router-view></router-view>-->
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'listExportPayment',
  props: {
    showSelect: { type: Boolean, default: true }
  },
  data () {
    return {
      headers: [
        {
          text: 'Код',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Идентификатор плательщика',
          align: 'start',
          sortable: false,
          value: 'payerIdentifier'
        },
        {
          text: 'Плательщик',
          align: 'start',
          sortable: false,
          value: 'payerName'
        },
        {
          text: 'Сумма платежа',
          align: 'start',
          sortable: false,
          value: 'amount'
        },
        {
          text: 'КБК',
          align: 'start',
          sortable: false,
          value: 'kbk'
        },
        // {
        //   text: 'УИП',
        //   align: 'start',
        //   sortable: false,
        //   value: 'paymentId'
        // },
        {
          text: 'Квитанция об оплате',
          align: 'start',
          sortable: false,
          value: 'report'
        }
      ]
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    search: {
      get () {
        return this.$store.getters['gis_gmpExportPayment/search']
      },
      set (value) {
        this.$store.commit('gis_gmpExportPayment/setSearch', value)
      }
    },
    selected: {
      get () {
        return this.$store.getters['gis_gmpExportPayment/selected']
      },
      set (value) {
        this.$store.commit('gis_gmpExportPayment/setSelected', value)
      }
    },
    pagination () {
      return this.$store.getters['gis_gmpExportPayment/pagination']
    },
    listExportPayment () {
      return this.$store.getters['gis_gmpExportPayment/listExportPayment']
    },
    title () {
      if (this.showSelect) {
        return 'Выбор квитанций об уплате'
      } else {
        return 'Список квитанций об уплате'
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize (newSearch = false) {
      this.$store.dispatch('gis_gmpExportPayment/fetchListExportPayment', {
        pageId: (newSearch) ? 1 : this.pagination.page,
        payer_id: this.$route.params.payer_id,
        search: this.search
      }).then(() => {
        if (newSearch) {
          this.pagination.page = 1
        }
      })
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
